/**
 * Sprint A · Historia A1 — cliente API del consolidado de auditoría
 * cerrada. Tipo reusable del shared (packages/shared/src/assessmentSummary.ts).
 */
import type { AssessmentSummary } from '@assessos/shared';

import { apiRequest } from './client.js';

export const assessmentSummaryApi = {
  get: (assessmentId: string) =>
    apiRequest<AssessmentSummary>(`/api/v1/assessments/${assessmentId}/summary`),
};
